import type { TenantConfig } from '@/types/TenantConfig'

export const broad: TenantConfig = {
  logo: 'assets/broad/static/logo.svg',
  teaserImageSize: {
    width: 408,
    height: 230,
  },
  themeOptions: {
    dialog: {
      backgroundColor: '#fff',
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/broad/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-160px',
        mobile: '-100px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      completedOrdersRoute: {
        ticketsOrderNumber: 'Your Order Number is {number}',
      },
      checkoutRoute: {
        title: '',
      },
    },
  },
}
